"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitResourceSelection = exports.getDeepLinkResourceLinks = void 0;
const api_1 = __importDefault(require("@aws-amplify/api"));
const rl_shared_1 = require("@asu-etx/rl-shared");
const hashUtils_1 = require("../utils/hashUtils");
const getDeepLinkResourceLinks = async (aws_exports) => {
    api_1.default.configure(aws_exports);
    const links = await api_1.default.get(rl_shared_1.LTI_API_NAME, rl_shared_1.DEEP_LINK_RESOURCELINKS_ENDPOINT, { queryStringParameters: { hash: hashUtils_1.getHash() } });
    return links;
};
exports.getDeepLinkResourceLinks = getDeepLinkResourceLinks;
const submitResourceSelection = async (aws_exports, resourceLink) => {
    api_1.default.configure(aws_exports);
    const data = {
        headers: {
            'Content-Type': 'application/json'
        }, body: {
            contentItems: [resourceLink],
            hash: hashUtils_1.getHash()
        }
    };
    const assignment = await api_1.default.post(rl_shared_1.LTI_API_NAME, rl_shared_1.DEEP_LINK_ASSIGNMENT_ENDPOINT, data);
    rl_shared_1.logger.debug(`assignment form: %${assignment}`);
    rl_shared_1.logger.debug(`hitting endpoint POST:${rl_shared_1.DEEP_LINK_ASSIGNMENT_ENDPOINT}`);
    return assignment.form;
};
exports.submitResourceSelection = submitResourceSelection;
